import Vue from "vue";
import router from "@/router";
import deepmerge from "deepmerge";
import om, { retry, to } from "../api";
import get from "lodash/get";
import * as END_POINTS from "../config/constants/end-points";
import * as ACTIONS from "../config/constants/action-types";
import * as MUTATIONS from "../config/constants/mutation-types";
import { agregarACola } from "../utils/promise-queue";
import { getParamMensajeContratacion } from "../config/constants/errores";
import config from "@/config/brands/ofertaPersonales";
import { getBranchOfficeById } from "@/utils";
import { sucursalDefault } from "../config/constants";
import { parseCurrency } from "../features/mortgage/simulator-income/helpers/utils";
import ASO, { withTsecAuth } from "../api/aso";

const aplicarNormalizacion = (respuesta, domicilio, flagBtd3 = false) => {
  /**
   * Helper para normalización de domicilios
   */
  let localidad = domicilio.localidad;
  let domicilioNormalizado = deepmerge({}, domicilio);

  Vue.$log.info("ACTION RESPUESTA VALIDMERLIN => " + respuesta.validMerlin);
  // Es válido?
  if (respuesta.validMerlin) {
    domicilioNormalizado = Object.assign(
      {},
      domicilioNormalizado,
      respuesta.domicilio
    );
    domicilioNormalizado.valido = true;
    domicilioNormalizado.provincia = respuesta.domicilio.codProvincia;
    /** 2021-07-06: Merlin no normaliza las ENIES vienen como ? */

    if (flagBtd3) {
      domicilioNormalizado.calle = get(domicilioNormalizado, "calle", "");
    } else {
      domicilioNormalizado.calle = get(domicilioNormalizado, "calle24", "");
    }
  } else {
    domicilioNormalizado.valido = false;
    // Si viene el flag reintentar, le pedimos al usuario
    // que modifique los datos e intente de nuevo
    domicilioNormalizado = Object.assign(
      {},
      domicilioNormalizado,
      respuesta.domicilio
    );
  }

  // Hardcodeamos la localidad
  domicilioNormalizado.localidad = localidad;
  return domicilioNormalizado;
};

const handleSelfieResponses = (context, responses, resolve, reject) => {
  responses.forEach(response => {
    const respuesta = get(response, "data", { status: "ERROR" });
    if (respuesta.status === "ERROR") {
      let strErrorToken = respuesta.respuesta.includes("Access token expired");
      let strExpired = respuesta.respuesta.includes(
        " La verificaciÃ³n no estÃ¡ abierta"
      );
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(
        MUTATIONS.ON_ERROR_VERIDAS,
        strErrorToken || strExpired ? "error-tokenExpired" : "error-selfie"
      );
      // Ocurrió un error, no llamar al getResult
      return reject();
    }
  });

  return resolve();
};

const handleGetResultResponse = (context, response, resolve, reject) => {
  if (
    get(response.data, "status", "ERROR") === "ERROR" ||
    get(response.data, "respuesta.mensaje", "ok") === "error"
  ) {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(MUTATIONS.ON_FUNNEL_ERROR, response.data);
    context.commit(MUTATIONS.ON_RESULT_VERIDAS, {
      isValid: false
    });
    context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-veridas");
    reject();
  } else if (response.data.respuesta.valid) {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(MUTATIONS.ON_BIOMETRIA_POSITIVO, {
      isValid: true
    });
    router.replace(
      config.pasos[config.pasos.loadingVeridas.pasoSiguiente].path
    );
    resolve();
  } else {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(MUTATIONS.ON_RESULT_VERIDAS, {
      isValid: false
    });
    context.commit(MUTATIONS.ON_ERROR_VERIDAS, "no-identificado-veridas");
    reject();
  }
};

const handleError = (context, error, reject) => {
  context.commit(MUTATIONS.ON_IS_LOADING, false);
  context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
  context.commit(MUTATIONS.ON_RESULT_VERIDAS, {
    isValid: false
  });
  context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-veridas");
  reject();
};

function getResultVeridas(context, resolve, reject) {
  return om
    .getResultVeridas(
      context.getters.getKeyLoginVeridas(),
      context.getters.getOferta().nroDeTramite,
      context.getters.getConsulta(),
      context.getters.getConsulta().numeroDoc,
      context.getters.getDeviceId(),
      context.getters.getDeviceIdTimestamp(),
      context.getters.getConsulta().tipoDocumento
    )
    .then(response => {
      handleGetResultResponse(context, response, resolve, reject);
    })
    .catch(error => handleError(context, error, reject));
}

const getResultPostDni = (response, context, resolve, reject) => {
  let respuesta = response.data;
  if (respuesta.status === "ERROR") {
    let strErrorToken = respuesta.respuesta.includes("Access token expired");
    let strExpired = respuesta.respuesta.includes(
      "La verificaciÃ³n no estÃ¡ abierta"
    );
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(
      MUTATIONS.ON_ERROR_VERIDAS,
      strErrorToken || strExpired ? "error-tokenExpired" : "error-dni"
    );
    reject();
  } else {
    resolve();
  }
};

const fetchSucursalesWithRetries = async (context, payload, retryCount = 0) => {
  try {
    const response = await om.sucursales(payload);
    if (response.data.status === "ERROR") {
      throw new Error(response.data.respuesta);
    }
    context.commit(MUTATIONS.ON_SUCURSALES, response.data.data);
  } catch (error) {
    //si hay error log, re-ejecucion y sumo counter
    Vue.$log.error(
      `Error en fetch sucursales. Intento: ${retryCount + 1}`,
      error
    );

    if (retryCount < 1) {
      // Maximo de dos reintentos en total
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(fetchSucursalesWithRetries(context, payload, retryCount + 1));
        }, 5000);
      });
    } else {
      // Si no funcionan los reintentos se selecciona sucursal torre por default
      context.commit(MUTATIONS.ON_SUCURSALES, sucursalDefault);
    }
  }
};

export default {
  /**
   * Action tcode
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.ON_TCODE](context, payload) {
    context.commit(MUTATIONS.ON_TCODE, payload);
  },
  /**
   * Action disparada por el router en
   * cada actualización
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.DO_ROUTE](context, payload) {
    context.commit(MUTATIONS.ON_ROUTE, payload);
    setTimeout(() => {
      // Detener loading al ingresar a ruta nueva
      // Lo hacemos en un timeout = 0 para hacer
      // al final del event loop
      // limpiar clase lock-scroll del dom por si queda ante un cierre inesperado de modal
      document.getElementsByTagName("html")[0].classList.remove("lock-scroll");
      context.commit(MUTATIONS.ON_IS_LOADING, false);
    }, 0);
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.DO_IS_LOADING](context, payload) {
    context.commit(MUTATIONS.ON_IS_LOADING, payload);
  },
  /**
   * Mostrar u ocultar el loader con texto
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.DO_IS_LOADING_WITH_CONTENT](context, payload) {
    const { loaderState, loaderContent } = payload;
    context.commit(MUTATIONS.ON_IS_LOADING, loaderState);
    context.commit(MUTATIONS.ON_LOADER_CONTENT, loaderContent);
  },
  /**
   * Action para actualizar la consulta en el state
   * @param {context} param0 Vue Context
   * @param {consulta payload} payload Consulta con nuevos datos
   */
  [ACTIONS.DO_UPDATE_CONSULTA]({ commit, state }, payload) {
    commit(MUTATIONS.ON_CONSULTA, { ...state.consulta, ...payload });
  },
  /**
   * Action para mostrar notificaciones en el front
   * en modo "toast"
   * @param {Object} context
   * @param {Object} payload: {type: String ["info", "success", "alert"], message: String}
   */
  [ACTIONS.DO_NOTIFICATION_TOAST](context, payload) {
    context.commit(MUTATIONS.ON_NOTIFICATION_TOAST, payload);
    setTimeout(() => {
      // Luego de 3 segundos quitamos la notificacion
      context.dispatch(ACTIONS.DO_NOTIFICATION_TOAST_RESET);
    }, 3000);
  },
  [ACTIONS.DO_NOTIFICATION_TOAST_RESET](context) {
    context.commit(MUTATIONS.ON_NOTIFICATION_TOAST, {
      type: "",
      message: ""
    });
  },
  /**
   * Action genérico para llamadas a la API
   * Se debe pasar el endpoint, el action a ejecutar en caso
   * de éxito y el action en caso de error
   * @param {Object} context Vue Context
   * @param {endPoint, payload, doSuccess, doError} actionPayload
   */
  [ACTIONS.DO_REQUEST_API](context, { endPoint, payload, doSuccess, doError }) {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    om.request({ endPoint, payload })
      .then(response => {
        Vue.$log.info(get(response, "data.respuesta"));
        if (
          get(response, "status", "ERROR") === "ERROR" ||
          get(response, "data.respuesta", "ok") === "error" ||
          get(response, "data.status") === "ERROR"
        ) {
          context.dispatch(doError, response.data.errorCode);
          return;
        }
        context.dispatch(doSuccess, response.data);
      })
      .catch(error => {
        context.dispatch(doError, error);
      })
      .finally(() => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
      });
  },
  /**
   * Actions disparadas por el
   * step navigator para avanzar pasos
   * Cada action guarda el paso
   * actual en el store
   * @param {Object} context
   */
  [ACTIONS.DO_LANDING]: (context, payload) => {
    // Indicar cargando
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    // Llamamos al action genérico de request
    // y especificamos el action de éxito y el de error
    // junto con el endpoint + payload
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTAR_OFERTA,
      doSuccess: ACTIONS.DO_LANDING_SUCCESS,
      doError: ACTIONS.DO_LANDING_ERROR,
      payload
    });
  },
  [ACTIONS.DO_LANDING_SUCCESS]: (context, payload) => {
    // Request landing exitosa
    context.commit(MUTATIONS.ON_LANDING, payload);
    // Ir a paso 1
    router.push("paso1");
  },
  [ACTIONS.DO_LANDING_ERROR]: (context, payload) => {
    // Consulta landing con error
    Vue.$log.error(payload);
    // Mostrar mensaje de error
    context.dispatch(ACTIONS.DO_MENSAJE, "mensaje-4");
  },
  [ACTIONS.DO_GRACIAS]: (context, payload) => {
    context.commit(MUTATIONS.ON_GRACIAS, payload);
  },
  /**
   * Mostrar un mensaje de error
   * @param {Object} context
   * @param {Object} payload Código del mensaje
   */
  [ACTIONS.DO_MENSAJE]: (context, payload) => {
    router.push({
      name: "mensaje",
      params: {
        mje: payload
      }
    });
  },
  [ACTIONS.DO_FORZAR_DNE]: ({ commit }, payload) => {
    commit(MUTATIONS.ON_FORZAR_DNE, payload);
  },
  [ACTIONS.DO_CONSULTAR]: (context, consulta) => {
    const payload = JSON.parse(JSON.stringify(consulta));
    context.commit(MUTATIONS.SET_RENAPER_CALLED, false);
    payload.captchaResponse = consulta.captcha;
    delete payload.captcha;
    payload.nroDoc = consulta.numeroDoc;
    payload.numeroDocumento = consulta.numeroDoc;
    delete payload.numeroDoc;
    payload.referrer = window.document.referrer;
    payload.originUrl = window.location.href;
    payload.celular = "";

    context.commit(MUTATIONS.SET_CONSULTA_PAYLOAD, payload);

    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTAR_EVALUACION,
      doSuccess: ACTIONS.DO_PRIMERA_CONSULTA_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_ERROR,
      payload
    });
    context.dispatch(ACTIONS.DO_GET_TOKEN_USER_ID, {
      nroDoc: consulta.numeroDoc,
      genero: consulta.sexo,
      tipoDoc: consulta.tipoDocumento
    });
  },
  [ACTIONS.DO_PRIMERA_CONSULTA_SUCCESS]: (context, payload) => {
    let simulacion = payload.respuesta;
    if (simulacion.respuesta != "ok") {
      if (
        simulacion.resultado.estado == "ACTUALIZAR_DATOS_RENAPER" &&
        !context.getters.getRenaperCalled()
      ) {
        context.commit(MUTATIONS.ON_OFERTA, simulacion);
        context.commit(MUTATIONS.SET_RENAPER_CALLED, true);
        context.dispatch(ACTIONS.DO_CONFIRMAR_RENAPER);
      } else if (simulacion.resultado.estado == "VALIDACION_COELSA_FALLIDA") {
        router.push({
          name: "continuaSucursal",
          params: { tipo: "riesgos" }
        });
      } else {
        router.push({
          name: "mensaje",
          params: {
            mje: simulacion.resultado.estado
          }
        });
      }
      context.commit(MUTATIONS.ADOBE_ERROR, simulacion.resultado.estado);
      context.commit(MUTATIONS.ON_ERROR, payload);
      return;
    }
    // Es una simulacion
    context.commit(MUTATIONS.ON_OFERTA, simulacion);
    // Es primera simulacion
    if (simulacion.esCliente != null) {
      router.push("oferta");
    }
  },
  [ACTIONS.DO_CONSULTA_SUCCESS]: (context, payload) => {
    let simulacion = payload.respuesta;
    if (simulacion.respuesta != "ok") {
      router.push({
        name: "mensaje",
        params: {
          mje: simulacion.resultado.estado
        }
      });
      context.commit(MUTATIONS.ADOBE_ERROR, simulacion.resultado.estado);
      context.commit(MUTATIONS.ON_ERROR, payload);
      return;
    }
    // Es una simulacion
    context.commit(MUTATIONS.ON_OFERTA, simulacion);
  },
  [ACTIONS.DO_CONSULTA_ERROR]: (context, payload) => {
    // Consulta landing con error
    Vue.$log.error(payload);
    // Mostrar mensaje de error
    router.push({ name: "mensaje", params: { mje: "errorGeneral" } });
    context.commit(MUTATIONS.ON_ERROR, payload);
  },
  [ACTIONS.DO_RECALCULO]: (context, consulta) => {
    const payload = {};
    payload.destino = consulta.destino;
    payload.diaDebito = consulta.diaDebito;
    if (typeof consulta.monto === "number") {
      payload.importeSolicitado = consulta.monto.toString().replace(/\D/g, "");
    } else {
      payload.importeSolicitado = consulta.monto.replace(/\D/g, "");
    }
    payload.cantidadCuotas = consulta.plazo;
    payload.randomKey =
      consulta.randomKey || context.getters.getSimulacion().randomKey;
    if (consulta.reSimulacionMobile === true) {
      payload.reSimulacionMobile = true;
    }
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTAR_EVALUACION,
      doSuccess: ACTIONS.DO_CONSULTA_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_ERROR,
      payload
    });
  },
  [ACTIONS.DO_ENVIAR_MAIL]: (context, email) => {
    const payload = {};
    payload.randomKey = context.getters.getSimulacion().randomKey;
    payload.email = email;

    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.ENVIAR_MAIL_SIMULACION,
      doSuccess: ACTIONS.DO_ENVIAR_MAIL_SUCCESS,
      doError: ACTIONS.DO_ENVIAR_MAIL_ERROR,
      payload
    });
  },
  [ACTIONS.DO_ENVIAR_MAIL_SUCCESS]: () => {},
  [ACTIONS.DO_ENVIAR_MAIL_ERROR]: context => {
    context.dispatch(ACTIONS.DO_NOTIFICATION_TOAST, {
      type: "alert",
      message: "Error al procesar el envío. Intente de nuevo más tarde."
    });
  },

  [ACTIONS.DO_LANDING_QR]: (context, shortUrl) => {
    context.commit(MUTATIONS.SET_LANDING_QR_URL, shortUrl);
    router.push("landingQR");
  },
  [ACTIONS.DO_SOLICITAR_PASO1]: () => {
    router.push("datosPersonales");
  },
  [ACTIONS.DO_DECRYPT_HR_DATOS]: async (context, params) => {
    const [error, response] = await to(om.decryptHrDatos(params));
    if (error || get(response, "data.status") !== "OK") {
      Vue.$log.error("Error al desencriptar hr_datos", error);
      return null;
    }
    const r = response.data.respuesta;
    const tipoDocMap = { DNI: "00", DNE: "31" };
    const celularActual = context.state.consulta.celular;
    context.commit(MUTATIONS.UPDATE_CONSULTA, {
      nombre: r.hrNombre || "",
      apellido: r.hrApellido || "",
      sexo: r.hrSexo || "F",
      numeroDoc: r.hrNumeroDoc || "",
      tipoDocumento: tipoDocMap[r.hrTipoDoc] || "00",
      fechaNacimiento:
        r.hrFechaNacDia && r.hrFechaNacMes && r.hrFechaNacAnio
          ? `${r.hrFechaNacDia}/${r.hrFechaNacMes}/${r.hrFechaNacAnio}`
          : "",
      email: r.hrEmail || "",
      celular: {
        ...celularActual,
        numero: r.validatedPhone || celularActual.numero
      },
      captcha: "CAPTCHA_VALIDATED"
    });
    return r;
  },
  [ACTIONS.DO_PASO1]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    payload.cuil = payload.cuil.replace(/\D/g, "");
    let domicilioMerlin = Object.assign({}, payload);
    if (domicilioMerlin.domicilioParticular.valido) {
      context.commit(MUTATIONS.ON_PASO1, domicilioMerlin);
      router.push(config.pasos.paso2.path);
    } else {
      const payloadMerlin = {
        randomKey: context.getters.getRandomKey(),
        domicilio: {
          calle: get(domicilioMerlin, "domicilioParticular.calle"),
          numero: get(domicilioMerlin, "domicilioParticular.numero"),
          piso: get(domicilioMerlin, "domicilioParticular.piso"),
          departamento: get(domicilioMerlin, "domicilioParticular.dpto"),
          codigoPostal: get(
            domicilioMerlin,
            "domicilioParticular.codigoPostal"
          ),
          barrio: "",
          localidad: get(domicilioMerlin, "domicilioParticular.localidad"),
          provincia: get(domicilioMerlin, "domicilioParticular.provincia")
        }
      };
      om.merlin(payloadMerlin, context.getters.getIsBTD3())
        .then(response => {
          context.commit(MUTATIONS.ON_CONTADOR_MERLIN);
          let respuesta = response.data;
          Vue.$log.info("Respuesta: ", respuesta);

          if (context.getters.getIsBTD3()) {
            context.dispatch(ACTIONS.DO_FETCH_SUCURSALES);
          } else {
            const { latitud, longitud } = respuesta.respuesta.domicilio;
            context.dispatch(ACTIONS.DO_FETCH_SUCURSALES, {
              latitud,
              longitud
            });
          }

          if (
            respuesta.status === "ERROR" ||
            !respuesta.respuesta.validMerlin
          ) {
            domicilioMerlin.domicilioParticular.valido = false;
            if (context.getters.getContadorLlamadosMerlin() > 1) {
              context.commit(MUTATIONS.ON_IS_BTD3, true);
            }
          }

          domicilioMerlin.domicilioParticular = aplicarNormalizacion(
            respuesta.respuesta,
            domicilioMerlin.domicilioParticular,
            context.getters.getIsBTD3()
          );

          context.commit(MUTATIONS.ON_PASO1, domicilioMerlin);
          if (domicilioMerlin.domicilioParticular.valido) {
            context.commit(MUTATIONS.ON_RESET_CONTADOR_MERLIN);
            context.commit(MUTATIONS.ON_IS_BTD3, false);
            router.push(config.pasos.paso2.path);
          }
        })
        .catch(error => {
          context.commit(MUTATIONS.ON_CONTADOR_MERLIN);
          Vue.$log.info(error);
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          if (context.getters.getContadorLlamadosMerlin() > 1) {
            context.commit(MUTATIONS.ON_IS_BTD3, true);
          }

          domicilioMerlin.domicilioParticular.valido = false;
          context.commit(MUTATIONS.ON_PASO1, domicilioMerlin);
        });
    }
  },
  [ACTIONS.DO_PASO2]: (context, payload) => {
    context.commit(MUTATIONS.ON_PASO2, payload);
  },
  [ACTIONS.DO_PASO3]: (context, payload) => {
    context.commit(MUTATIONS.ON_PASO3, payload);
    // Verifico que no haya elegido PEP o SO
    if (
      get(payload, "pep", "0") === "1" ||
      get(payload, "fatca", "0") === "1" ||
      get(payload, "sujetoObligado", "0") === "1"
    ) {
      router.push({
        name: "continuaSucursal",
        params: { tipo: "general" }
      });
      return;
    }
    // Envío al paso siguiente
    router.push(config.pasos[config.pasos.paso3.pasoSiguiente].path);
  },
  [ACTIONS.DO_PRESENCIAL](context, payload) {
    context.commit(MUTATIONS.ON_THANKS_VERIDAS, false);
    context.commit(MUTATIONS.ON_PRESENCIAL, payload);
    router.push(config.pasos.consulta.path); //ver que ruta para presencial TODO
  },
  [ACTIONS.DO_DIGITAL](context, payload) {
    context.commit(MUTATIONS.ON_THANKS_VERIDAS, false);
    context.commit(MUTATIONS.ON_DIGITAL, payload);
  },
  [ACTIONS.DO_DATA_AUTH_ASO](context, payload) {
    context.commit(MUTATIONS.ON_DATA_AUTH_ASO, payload);
  },
  [ACTIONS.DO_ENVIAR_EVENTO_DVS_FS]: async context => {
    try {
      const eventoPayload = {
        nroDoc: context.getters.getConsulta().numeroDoc,
        c: context.getters.getCircuito(),
        tipoDocumento: context.getters.getConsulta().tipoDocumento,
        deviceId: context.getters.getDeviceId(),
        deviceIdTimestamp: context.getters.getDeviceIdTimestamp(),
        numeroCliente: context.getters.getConsulta().numeroDoc,
        idBiometria: context.getters.getDVSIframeData().id
      };
      await om.enviarEventoDvsFS(eventoPayload);
    } catch (error) {
      Vue.$log.error(error);
      context.commit(MUTATIONS.ON_ERROR, error);
    }
  },
  [ACTIONS.GET_REINTENTOS_BIO]: async context => {
    try {
      let numDoc = context.getters.getConsulta().numeroDoc;
      const response = await om.consultarReintentosBio(numDoc);
      //back responde OK, pero campo ERROR por dni vacio
      if (response.data.status === "ERROR") {
        router.push({
          name: "mensajeVeridas",
          params: { mje: "error-servidor" }
        });
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        context.commit(MUTATIONS.ON_ERROR, "error-servidor");
        return false;
      }

      if (!response.data.respuesta) {
        // Agoto reintentos
        router.push({
          name: "mensajeVeridas",
          params: { mje: "error-reintentos-biometria" }
        });
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        context.commit(MUTATIONS.ON_ERROR, "error-reintentos-biometria");
        return false;
      }
      return true;
    } catch (error) {
      Vue.$log.error(error);
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(MUTATIONS.ON_ERROR, error);
      router.push({
        name: "mensajeVeridas",
        params: { mje: "error-servidor" }
      });
    }
  },
  [ACTIONS.GET_VERIDAS_IFRAME]: async context => {
    try {
      const response = await withTsecAuth(ASO.getVeridasIframe);
      const iframeData = response.data.data;

      //responde OK, pero campos con error
      if (!("id" in iframeData) || !("urlXpressId" in iframeData)) {
        let message = "Error: La respuesta no contiene los datos del iframe.";
        Vue.$log.error(message, response);
        context.commit(MUTATIONS.ON_ERROR, message);
        router.push({
          name: "mensajeVeridas",
          params: { mje: "error-servicio-veridas" }
        });
        return;
      }

      context.commit(MUTATIONS.SET_DVS_IFRAME_DATA, iframeData);
      context.dispatch(ACTIONS.DO_ENVIAR_EVENTO_DVS_FS);
      return iframeData;
    } catch (error) {
      Vue.$log.error(error);
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(MUTATIONS.ON_ERROR, error);
      router.push({
        name: "mensajeVeridas",
        params: { mje: "error-servicio-aso" }
      });
    }
  },
  [ACTIONS.GET_VERIDAS_RESULT]: async (context, pendingCount = 0) => {
    try {
      const response = await withTsecAuth(
        ASO.getVeridasResult,
        context.getters.getDVSIframeData().id
      );

      const responseData = response.data.data;

      if (responseData.result === "PENDING") {
        if (pendingCount >= 12) {
          const error = "Timeout veridas";
          Vue.$log.error(error);
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          context.commit(MUTATIONS.ON_ERROR, error);
          context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-veridas");
          return;
        }
        return setTimeout(() => {
          context.dispatch(ACTIONS.GET_VERIDAS_RESULT, pendingCount + 1);
        }, 3000);
      }

      if (responseData.result === "OK" || responseData.result === "KO") {
        context.dispatch(ACTIONS.GET_RENAPER_VALIDATION);
      } else {
        let error = `Error getting Veridas Result: ${response}`;
        Vue.$log.error(error);
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        context.commit(MUTATIONS.ON_ERROR, error);
        context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-veridas");
      }
      return;
    } catch (error) {
      Vue.$log.error(error);
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(MUTATIONS.ON_ERROR, error);
      context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-aso");
    }
  },
  [ACTIONS.GET_RENAPER_VALIDATION]: async (context, pendingCount = 0) => {
    try {
      /**
       * Llamar al ASO de Renaper y reintentar en caso de fallo
       * En ambientes previos puede fallar por error 400 en caso
       * de no contar con la info aún en base de datos
       * Se reintenta hasta 5 veces con un delay de 3 segundos
       */
      const [error, response] = await retry(
        () =>
          withTsecAuth(
            ASO.getRenaperValidation,
            context.getters.getDVSIframeData().id
          ),
        3000,
        5
      );
      if (error) {
        Vue.$log.error(error);
        throw error;
      }

      const responseData = response.data.data;

      if (responseData.result === "PENDING") {
        if (pendingCount >= 12) {
          const error = "Timeout veridas";
          Vue.$log.error(error);
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          context.commit(MUTATIONS.ON_ERROR, error);
          context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-veridas");
          return;
        }
        return setTimeout(() => {
          context.dispatch(ACTIONS.GET_RENAPER_VALIDATION, pendingCount + 1);
        }, 3000);
      }

      if (responseData.result === "FINISHED") {
        context.dispatch(ACTIONS.DO_ENVIAR_RESULTADOS_BIOMETRIA, responseData);
      } else {
        let message = "Error: falla resultados validacion.";
        Vue.$log.error(message, response);
        context.commit(MUTATIONS.ON_ERROR, message);
        context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-renaper");
        return;
      }
    } catch (error) {
      Vue.$log.error(error);
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(MUTATIONS.ON_ERROR, error);
      context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-aso");
    }
  },
  [ACTIONS.DO_ENVIAR_RESULTADOS_BIOMETRIA]: async (context, payload) => {
    try {
      const dvsStatusType = payload.message?.dvsStatusType;
      const renaper3Result = payload.message?.renaper3Desc?.validationResult;
      const renaper2Result = payload.message?.renaper2Desc?.validationResult;

      const dataOcr = payload.message?.dataOcrDesc || [];

      const getValue = (arr, key) =>
        arr.find(item => item.name === key)?.value || null;

      let dataOcrVeridas = {
        number: getValue(dataOcr, "DD_DocumentNumber_Out"),
        gender: getValue(dataOcr, "PD_Sex_Out"),
        names: getValue(dataOcr, "PD_Name_Out"),
        lastNames: getValue(dataOcr, "PD_LastName_Out"),
        birthDate: getValue(dataOcr, "PD_BirthDate_Out")
      };

      let body = {
        idBiometria: payload.id,
        valid: true,
        numTramite: context.getters.getOferta().nroDeTramite || "",
        personDataResponse: payload.message.renaper3Desc || "",
        ocrVeridas: dataOcrVeridas,
        circuito: context.getters.getCircuito(),
        docNumEval: context.getters.getConsulta().numeroDoc,
        fechaNacEval: context.getters.getConsulta().fechaNacimiento,
        tipoDocumento: context.getters.getConsulta().tipoDocumento,
        deviceId: context.getters.getDeviceId(),
        deviceIdTimestamp: context.getters.getDeviceIdTimestamp(),
        numeroCliente: context.getters.getConsulta().numeroDoc
      };

      const isValidVeridas =
        dvsStatusType === "OK" &&
        renaper3Result === "OK" &&
        renaper2Result === "OK";

      body.valid = isValidVeridas;

      /** Enviamos validación al back OM */
      const response = await om.enviarResultadosBiometria(body);
      const isValidOm = get(response, "data.respuesta.valid", false);
      const puedeReintentar = get(
        response,
        "data.respuesta.puedeReintentar",
        false
      );

      /** tenemos una biometría válida */
      if (isValidVeridas && isValidOm) {
        return router.replace(
          config.pasos[config.pasos.loadingVeridas.pasoSiguiente].path
        );
      }

      /** No tenemos una biometría válida, puede reintentar */
      if (puedeReintentar) {
        return context.commit(
          MUTATIONS.ON_ERROR_VERIDAS,
          "error-veridas-result"
        );
      }

      /** No puede reintentar, fin del circuito! */
      context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-reintentos-biometria");
    } catch (error) {
      /** Ocurrió un error de servicio */
      Vue.$log.error(error);
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(MUTATIONS.ON_ERROR, error);
      context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-aso");
    }
  },
  [ACTIONS.DO_POST_FRONT_DNI]: (context, payload) => {
    agregarACola(() => {
      return new Promise((resolve, reject) => {
        context.commit(MUTATIONS.ON_RESULT_VERIDAS, {
          isValid: null
        });
        context.commit(MUTATIONS.ON_IS_LOADING, true);
        context.commit(MUTATIONS.ON_ERROR_VERIDAS, "");

        let param = {
          nroDoc: context.getters.getConsulta().numeroDoc,
          c: context.getters.getCircuito(),
          tipoDocumento: context.getters.getConsulta().tipoDocumento,
          numeroCliente: context.getters.getConsulta().numeroDoc,
          deviceId: context.state.deviceId,
          deviceIdTimestamp: context.state.deviceIdTimestamp
        };

        om.loginVeridas(param)
          .then(resultLogin => {
            context.commit(MUTATIONS.ON_IS_LOADING, false);
            let data = resultLogin.data;
            if (data.status === "OK") {
              let res = data.respuesta;
              context.commit(MUTATIONS.ON_LOGIN, res);
              return resolve();
            }

            context.commit(
              MUTATIONS.ON_ERROR_VERIDAS,
              "error-servicio-veridas"
            );
            reject();
          })
          .catch(error => {
            Vue.$log.info(error);
            context.commit(MUTATIONS.ON_ERROR, error);
            context.commit(
              MUTATIONS.ON_ERROR_VERIDAS,
              "error-servicio-veridas"
            );
            reject();
          });
      });
    });

    agregarACola(() => {
      return new Promise((resolve, reject) => {
        payload.append("key", context.getters.getKeyLoginVeridas());
        om.envioFrenteDni(payload)
          .then(resultAttach => {
            getResultPostDni(resultAttach, context, resolve, reject);
          })
          .catch(error => {
            Vue.$log.info(error);
            context.commit(MUTATIONS.ON_ERROR, error);
            context.commit(
              MUTATIONS.ON_ERROR_VERIDAS,
              "error-servicio-veridas"
            );
            reject();
          });
      });
    });
  },
  [ACTIONS.DO_POST_REVERSE_DNI](context, payload) {
    const errorVeridas = get(context, "state.errorVeridas", "");
    if (errorVeridas) return;
    agregarACola(() => {
      return new Promise((resolve, reject) => {
        payload.append("key", context.getters.getKeyLoginVeridas());
        om.envioReversoDni(payload)
          .then(response => {
            let respuesta = response.data;
            Vue.$log.info(respuesta);
            if (respuesta.status === "ERROR") {
              let strErrorToken = respuesta.respuesta.includes(
                "Access token expired"
              );
              let strExpired = respuesta.respuesta.includes(
                "La verificaciÃ³n no estÃ¡ abierta"
              );
              context.commit(MUTATIONS.ON_IS_LOADING, false);
              context.commit(
                MUTATIONS.ON_ERROR_VERIDAS,
                strErrorToken || strExpired ? "error-tokenExpired" : "error-dni"
              );
              reject();
            } else {
              resolve();
            }
          })
          .catch(error => {
            Vue.$log.info(error);
            context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
            context.commit(
              MUTATIONS.ON_ERROR_VERIDAS,
              "error-servicio-veridas"
            );
            reject();
          });
      });
    });
  },

  [ACTIONS.DO_POST_SELFIES_PROMISE](context, { dataSelfie, dataSelfieAlive }) {
    /**
     * Enviar Selfie
     */
    const errorVeridas = get(context, "state.errorVeridas", "");
    if (errorVeridas) return;
    dataSelfie.append("key", context.getters.getKeyLoginVeridas());
    agregarACola(() => {
      return new Promise((resolve, reject) => {
        om.envioSelfie(dataSelfie)
          .then(response => {
            handleSelfieResponses(context, [response], resolve, reject);
          })
          .catch(error => {
            context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
            context.commit(MUTATIONS.ON_RESULT_VERIDAS, {
              isValid: false
            });
            context.commit(
              MUTATIONS.ON_ERROR_VERIDAS,
              "error-servicio-veridas"
            );
            reject();
          });
      });
    });

    /**
     * Enviar Selfie Alive
     */
    dataSelfieAlive.append("key", context.getters.getKeyLoginVeridas());
    agregarACola(() => {
      return new Promise((resolve, reject) => {
        om.envioSelfieAlive(dataSelfieAlive)
          .then(response => {
            handleSelfieResponses(context, [response], resolve, reject);
          })
          .catch(error => {
            context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
            context.commit(MUTATIONS.ON_RESULT_VERIDAS, {
              isValid: false
            });
            context.commit(
              MUTATIONS.ON_ERROR_VERIDAS,
              "error-servicio-veridas"
            );
            reject();
          });
      });
    });

    /**
     * Enviar Get Result
     */
    agregarACola(() => {
      return new Promise((resolve, reject) => {
        const errorVeridas = get(context, "state.errorVeridas", "");
        if (errorVeridas) return reject();
        getResultVeridas(context, resolve, reject);
      });
    });
  },
  [ACTIONS.DO_ERROR_SELFIES]: (context, payload) => {
    let strErrorToken = payload.respuesta.includes("Access token expired");
    let strExpired = payload.respuesta.includes(
      "La verificaciÃ³n no estÃ¡ abierta"
    );
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(
      MUTATIONS.ON_ERROR_VERIDAS,
      strErrorToken || strExpired ? "error-tokenExpired" : "error-selfie"
    );
  },
  [ACTIONS.DO_POST_SELFIE]: () => {},
  [ACTIONS.DO_POST_SELFIE_ALIVE]: () => {
    router.push(config.pasos.loadingVeridas.path);
  },
  [ACTIONS.DO_DIA_DEBITO]: (context, payload) => {
    context.commit(MUTATIONS.ON_DIA_DEBITO, payload);
  },
  [ACTIONS.DO_SEARCH_CONTRACTS]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    let listContract = [];
    let promisesContracts = [];
    om.getContract(payload)
      .then(response => {
        Vue.$log.info(
          `Contratos encontrados mediante un nro de tramite ${payload.numeroTramite}`,
          response
        );
        if (response.data.status === "OK") {
          let contracts = response.data.respuesta.contratos;

          for (const contract of contracts) {
            let dataContract = {
              claseDocumental: contract.claseDocumental,
              idImagen: contract.idImagen
            };
            listContract.push({
              urlPDFBase64: "",
              idForm: contract.idFormulario
            });

            let promisesContract = om.downloadContract(dataContract);
            promisesContracts.push(promisesContract);
          }
        } else {
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          router.push({
            name: "mensaje",
            params: {
              mje: "mensaje-4"
            }
          });
        }
        Promise.all(promisesContracts)
          .then(response => {
            for (let i = 0; i < response.length; i++) {
              let binary = atob(response[i].data.respuesta.replace(/\s/g, ""));
              let len = binary.length;
              let buffer = new ArrayBuffer(len);
              let view = new Uint8Array(buffer);
              for (let j = 0; j < len; j++) {
                view[j] = binary.charCodeAt(j);
              }
              let blob = new Blob([view], { type: "application/pdf" });
              listContract[i].urlPDFBase64 = URL.createObjectURL(blob);
            }
            context.commit(MUTATIONS.ON_CONSULTA_CONTRATO, listContract);
            context.commit(MUTATIONS.ON_IS_LOADING, false);
          })
          .catch(error => {
            context.commit(MUTATIONS.ON_IS_LOADING, false);
            Vue.$log.info(error);
          });
      })
      .catch(error => {
        context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        router.push({
          name: "mensaje",
          params: {
            mje: "mensaje-4"
          }
        });
      });
  },
  [ACTIONS.DO_SIGN_CONTRACTS]: (context, payload) => {
    if (get(context, "state.contratosFirmados", false)) {
      // EL usuario ya ha realizado la contratación.
      router.push({
        name: "mensaje",
        params: {
          mje: "ya-contrato"
        }
      });
      return false;
    }
    let contracts = context.getters.getContractsPdf();
    let signContracts = {
      contratosFirmados: {},
      numeroTramite: context.getters.getNumeroTramite(),
      randomKey: context.getters.getRandomKey()
    };

    for (let contract of contracts) {
      let key = contract.idForm;
      signContracts.contratosFirmados[key] = signTime(key)[key];
    }

    function signTime(key) {
      let d = new Date(),
        dformat =
          [
            d.getFullYear(),
            evalNumber(d.getMonth() + 1),
            evalNumber(d.getDate())
          ].join("-") +
          "-" +
          [
            evalNumber(d.getHours()),
            evalNumber(d.getMinutes()),
            evalNumber(d.getSeconds()),
            d.getMilliseconds()
          ].join(".");
      let obj = {};
      obj[key] = dformat;
      return obj;
    }

    function evalNumber(number) {
      if (number < 10) {
        number = "0" + number.toString();
      }
      return number;
    }
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    om.signContracts(signContracts)
      .then(response => {
        if (response.data.status === "OK") {
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          context.commit(MUTATIONS.ON_PASO8, payload);
          context.commit(MUTATIONS.ON_FIRMA_CONTRATOS);
          router.push(config.pasos[config.pasos.contratos.pasoSiguiente].path);
        } else {
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          router.push({
            name: "mensaje",
            params: {
              mje: "mensaje-4"
            }
          });
        }
      })
      .catch(error => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        Vue.$log.info(error);
        context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
        router.push({
          name: "mensaje",
          params: {
            mje: "mensaje-4"
          }
        });
      });
  },
  [ACTIONS.DO_NORMALIZE]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    let domicilioMerlin = Object.assign({}, payload.payload);
    if (domicilioMerlin.valido) {
      if (payload.selectDomicilio === "otro") {
        context.commit(MUTATIONS.ON_NORMALIZE_ALTERNATIVO, domicilioMerlin);
      } else {
        context.commit(MUTATIONS.ON_NORMALIZE_PARTICULAR, domicilioMerlin);
      }
      return Promise.resolve(true);
    } else {
      const payloadMerlin = {
        randomKey: context.getters.getRandomKey(),
        domicilio: {
          calle: get(domicilioMerlin, "calle", ""),
          numero: get(domicilioMerlin, "numero", ""),
          piso: get(domicilioMerlin, "piso", ""),
          departamento: get(domicilioMerlin, "dpto", ""),
          codigoPostal: get(domicilioMerlin, "codigoPostal", ""),
          barrio: "",
          localidad: get(domicilioMerlin, "localidad", ""),
          provincia: get(domicilioMerlin, "provincia", "")
        }
      };
      return om
        .merlin(payloadMerlin, context.getters.getIsBTD3())
        .then(response => {
          context.commit(MUTATIONS.ON_CONTADOR_MERLIN);
          let respuesta = response.data;
          Vue.$log.info("Respuesta: ", respuesta);

          if (context.getters.getIsBTD3()) {
            context.dispatch(ACTIONS.DO_FETCH_SUCURSALES);
          } else {
            const { latitud, longitud } = respuesta.respuesta.domicilio;
            if (payload.selectDomicilio !== "otro") {
              context.dispatch(ACTIONS.DO_FETCH_SUCURSALES, {
                latitud,
                longitud
              });
            }
          }

          if (
            respuesta.status === "ERROR" ||
            !respuesta.respuesta.validMerlin
          ) {
            domicilioMerlin.valido = false;
            if (context.getters.getContadorLlamadosMerlin() > 1) {
              context.commit(MUTATIONS.ON_IS_BTD3, true);
            }
          }

          domicilioMerlin = aplicarNormalizacion(
            respuesta.respuesta,
            domicilioMerlin,
            context.getters.getIsBTD3()
          );

          if (payload.selectDomicilio === "otro") {
            context.commit(MUTATIONS.ON_NORMALIZE_ALTERNATIVO, domicilioMerlin);
          } else {
            context.commit(MUTATIONS.ON_NORMALIZE_PARTICULAR, domicilioMerlin);
          }
          context.commit(MUTATIONS.ON_RESET_CONTADOR_MERLIN);
          return domicilioMerlin.valido;
        })
        .catch(() => {
          context.commit(MUTATIONS.ON_CONTADOR_MERLIN);
          if (context.getters.getContadorLlamadosMerlin() > 1) {
            context.commit(MUTATIONS.ON_IS_BTD3, true);
          }
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          return false;
        });
    }
  },
  [ACTIONS.DO_SELECT_DOMICILIO_NORMALIZADO_PARTICULAR]: (
    { commit, state, dispatch },
    payload
  ) => {
    let commitPayloadStep1 = deepmerge.all(
      [
        {},
        state.paso1,
        {
          domicilioParticular: {
            lineas: [],
            calle: payload.calleLocalidad,
            codigoPostal: payload.codigoPostal,
            valido: true
          }
        }
      ],
      { arrayMerge: (a, b) => b }
    );
    let commitPayloadEntrega = deepmerge.all(
      [
        {},
        state.entrega,
        {
          domicilioParticular: {
            lineas: [],
            calle: payload.calleLocalidad,
            codigoPostal: payload.codigoPostal,
            valido: true
          }
        }
      ],
      { arrayMerge: (a, b) => b }
    );
    commit(MUTATIONS.ON_PASO1, commitPayloadStep1);
    commit(MUTATIONS.ON_ENTREGA, commitPayloadEntrega);
    commit(MUTATIONS.ON_IS_LOADING, false);
    dispatch(ACTIONS.DO_FETCH_SUCURSALES, {
      latitud: payload.latitud,
      longitud: payload.longitud
    });
  },
  [ACTIONS.DO_CONSULTA_RENAPER]: () => {
    router.push(config.pasos.renaperConsultar.path);
  },
  [ACTIONS.DO_CONFIRMAR_RENAPER]: () => {
    router.push(config.pasos.renaperConfirmar.path);
  },
  [ACTIONS.DO_SELECT_DOMICILIO_NORMALIZADO_ALTERNATIVO]: (
    { commit, state },
    payload
  ) => {
    let commitPayload = deepmerge.all(
      [
        {},
        state.entrega,
        {
          otroDomicilio: {
            lineas: [],
            calle: payload.calleLocalidad,
            codigoPostal: payload.codigoPostal,
            valido: true
          }
        }
      ],
      { arrayMerge: (a, b) => b }
    );
    commit(MUTATIONS.ON_ENTREGA, commitPayload);
    commit(MUTATIONS.ON_IS_LOADING, false);
  },
  [ACTIONS.DO_VALIDAR_CELULAR]: (context, payload) => {
    let deviceUdid = context.getters.getDeviceUdid();
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    let body = {
      claveOTP: {
        otp: payload.otp,
        deviceUdid: deviceUdid
      },
      nroCliente:
        context.getters.getSimulacion().resultado.clientePrestamo.idAltamira,
      telefono: context.getters.getCelular().numero,
      operador: context.getters.getCelular().compania,
      circuito: context.getters.getCircuito(),
      otp: true
    };
    om.certificarCelular(body)
      .then(response => {
        if (
          get(response.data, "status", "ERROR") === "ERROR" ||
          !response.data.respuesta.otp
        ) {
          context.commit(MUTATIONS.ON_OTP_ERROR);
          context.commit(MUTATIONS.ON_ERROR, response.data);
          router.push({
            name: "mensaje",
            params: {
              mje: "mensaje-4"
            }
          });
        } else {
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          context.commit(MUTATIONS.ON_VALIDAR_CELULAR, {
            ...payload,
            otpValid: true
          });
          context.dispatch(ACTIONS.DO_NOTIFICATION_TOAST, {
            type: "success",
            message: "Tu celular se validó exitosamente."
          });
          router.push(config.pasos[config.pasos.celular.pasoSiguiente].path);
        }
      })
      .catch(error => {
        context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
        context.commit(MUTATIONS.ON_OTP_ERROR);
        router.push({
          name: "mensaje",
          params: {
            mje: "mensaje-4"
          }
        });
      })
      .finally(() => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
      });
  },
  [ACTIONS.DO_ENVIO_CELULAR]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    om.generarOtp(payload)
      .then(response => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        let data = response.data;
        if (data.status === "OK") {
          let bodyData = {
            otp: data.respuesta.otp,
            deviceUdid: payload.deviceUdid
          };
          context.commit(MUTATIONS.ON_OTP_ONE, bodyData);
          context.dispatch(ACTIONS.DO_NOTIFICATION_TOAST, {
            type: "success",
            message: "Te enviamos un SMS a tu celular."
          });
        } else {
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          router.push({
            name: "mensaje",
            params: {
              mje: "mensaje-4"
            }
          });
        }
      })
      .catch(error => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
        router.push({
          name: "mensaje",
          params: {
            mje: "mensaje-4"
          }
        });
      });
  },
  [ACTIONS.DO_CREAR_USUARIO]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.commit(MUTATIONS.ON_CREAR_USUARIO, payload);
    let randomKey = context.getters.getRandomKey();
    payload.randomKey = randomKey;
    om.crearUsuario(payload)
      .then(response => {
        Vue.$log.info("Se ha creado el usuario correctamente", response);
        router.push(config.pasos[config.pasos.usuario.pasoSiguiente].path);
        context.commit(MUTATIONS.ON_IS_LOADING, false);
      })
      .catch(error => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
        router.push({
          name: "mensaje",
          params: {
            mje: "mensaje-4"
          }
        });
      });
  },
  [ACTIONS.DO_CONFIRMACION]: (context, payload) => {
    if (get(context, "state.contratacionFinalizada", false)) {
      // EL usuario ya ha realizado la contratación.
      // router.push({
      //   name: "mensaje",
      //   params: {
      //     mje: "ya-contrato"
      //   }
      // });
      router.push(config.pasos[config.pasos.entrega.pasoSiguiente].path);
      return false;
    }
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    om.confirmacion(context.getters.getConfirmacionDataVeridas())
      .then(response => {
        let respuesta = response.data;
        if (get(respuesta, "respuesta.errores[0]", []) === "Fallo engage") {
          // Contratación exitosa - aunque falla engage
          payload.numeroTramite = respuesta.respuesta.nroDeTramite;
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          context.commit(MUTATIONS.ON_ENTREGA, payload);
          context.commit(MUTATIONS.ON_THANKS_VERIDAS, true);
          context.commit(MUTATIONS.ON_CONTRATACION, respuesta.respuesta);
          router.push(config.pasos[config.pasos.entrega.pasoSiguiente].path);
          return false;
        }
        if (get(respuesta, "respuesta.errores[0]", "").includes("YQE0235")) {
          // Contratación para reintento con cron - job toma la tabla cobol - 24X7
          context.commit(MUTATIONS.ON_CONTRATACION, respuesta.respuesta);
          router.push(config.pasos[config.pasos.entrega.pasoSiguiente].path);
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          return false;
        }
        if (
          get(response.data, "status", "ERROR") === "ERROR" ||
          get(response.data, "respuesta.mensaje", "ok") === "error"
        ) {
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          context.commit(MUTATIONS.ON_FUNNEL_ERROR, response.data);
          router.push({
            name: "mensaje",
            params: {
              mje: getParamMensajeContratacion(
                get(response, "data.respuesta.errores", [])
              )
            }
          });
          context.commit(MUTATIONS.ON_FUNNEL_ERROR, response);
        } else {
          // Contratación exitosa
          payload.numeroTramite = response.data.respuesta.nroDeTramite;
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          context.commit(MUTATIONS.ON_ENTREGA, payload);
          context.commit(MUTATIONS.ON_CONTRATACION, response.data.respuesta);
          context.commit(MUTATIONS.ON_THANKS_VERIDAS, true);
          router.push(config.pasos[config.pasos.entrega.pasoSiguiente].path);
        }
      })
      .catch(error => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        router.push({
          name: "mensaje",
          params: {
            mje: "mensaje-4"
          }
        });
        context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
      });
  },
  [ACTIONS.DO_FETCH_SUCURSALES](
    context,
    payload = { latitud: "-34.6037345", longitud: "-58.3837591" }
  ) {
    context.dispatch(ACTIONS.DO_IS_LOADING, true);
    return fetchSucursalesWithRetries(context, payload, 0);
  },
  [ACTIONS.DO_PRELOAD_SDK](context, payload) {
    context.commit(MUTATIONS.ON_PRELOAD_SDK, payload);
  },
  [ACTIONS.DO_IS_VISIBLE_SDK](context, payload) {
    context.commit(MUTATIONS.ON_IS_VISIBLE_SDK, payload);
  },
  [ACTIONS.DO_SAVE_IFRAME](context, payload) {
    context.commit(MUTATIONS.ON_SAVE_IFRAME, payload);
  },
  [ACTIONS.DO_NORMALIZARCELULAR](context, payload) {
    if (payload.status !== "CO") {
      context.commit(MUTATIONS.ON_NORMALIZARCELULAR, { valido: false });
    } else {
      const celularNormalizado = {
        area: Number(payload.ddn).toString(),
        nro: payload.phoneNumber,
        caracteristica: payload.characteristic,
        valido: true
      };
      context.commit(MUTATIONS.ON_NORMALIZARCELULAR, celularNormalizado);
    }
  },
  [ACTIONS.DO_ACTUALIZAR_ESTADO_TYC]: context => {
    context.commit(MUTATIONS.ON_ACTUALIZAR_ESTADO_TYC);
  },
  /**
   * Action que permite a Adobe Target inyectar en el store
   * el código de la actividad que debe seleccionarse
   * @uso (desde afuera): BBVA_APP.$store.dispatch('SET_ADOBE_TARGET_EXPERIENCE', 'AR062019_B')
   */
  [ACTIONS.SET_ADOBE_TARGET_EXPERIENCE]: (context, payload) => {
    context.commit(MUTATIONS.ON_ADOBE_TARGET_EXPERIENCE, payload);
  },
  /**
   * Setea el monto solicitado por vivienda como monto maximo
   **/
  [ACTIONS.DO_SET_MAX_AMOUNT]: (context, payload) => {
    context.commit(MUTATIONS.SET_MAX_AMOUNT, payload);
  },
  [ACTIONS.DO_GET_TOKEN_USER_ID]: (context, payload) => {
    return om
      .tokenizarUser(payload)
      .then(response => {
        let respuesta = response.data;
        if (respuesta.status === "OK") {
          let userIdTokenizado = respuesta.respuesta.customerID;
          context.commit(MUTATIONS.ON_USER_ID_TOKENIZADO, userIdTokenizado);
        }
      })
      .catch(error => {
        Vue.$log.error(error);
      });
  },
  [ACTIONS.DO_GET_DEVICEID]: (context, payload) => {
    context.commit(MUTATIONS.ON_DEVICEID, payload);
  },
  [ACTIONS.DO_GET_DEVICEIDTIMESTAMP]: (context, payload) => {
    context.commit(MUTATIONS.ON_DEVICEIDTIMESTAMP, payload);
  },
  [ACTIONS.DO_SEND_SMS]: (context, payload) => {
    return om
      .enviarSms(payload)
      .then(response => {
        Vue.$log.info(response);
      })
      .catch(error => {
        Vue.$log.error(error);
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        router.push({
          name: "mensaje",
          params: {
            mje: "mensaje-4"
          }
        });
      });
  },
  [ACTIONS.DO_GET_LINEAS_PH]: context => {
    om.consultaLineasPH().then(response => {
      context.commit(MUTATIONS.ON_LINEAS_PH, response.data.respuesta);
    });
  },
  [ACTIONS.DO_CONSULTA_PH]: async ({ commit, dispatch }, consulta) => {
    const montoSolicitado = Number(
      consulta.montoSolicitado.toString().replace(/\D/g, "")
    );

    const valorPropiedad = Number(
      consulta.valorPropiedad.toString().replace(/\D/g, "")
    );
    const consultaPayload = {
      modo: "T",
      codTipoProducto: "11",
      montoSolicitado,
      valorPropiedad,
      ingresos: 0,
      plazo: consulta.plazo * 12,
      tipoVivienda: consulta.destino,
      cuentaSueldo: consulta.cuentaSueldo === "1"
    };
    const loaderContent = {
      loaderTitle: "Estamos calculando los resultados de tu simulación",
      loaderText:
        "El proceso puede tardar unos segundos. Por favor, no actualices esta pantalla."
    };

    dispatch(ACTIONS.DO_IS_LOADING_WITH_CONTENT, {
      loaderState: true,
      loaderContent
    });
    try {
      const response = await om.consultaPH(consultaPayload);
      if (response.data.status === "ERROR") {
        commit(MUTATIONS.ON_ERROR, response.data.respuesta);
        throw new Error(response.data.respuesta);
      }
      //se copian plazo y montoSolicitado de la consulta para guardado de datos
      const simulacion = {
        ...response.data.respuesta,
        plazo: consulta.plazo,
        valorPropiedad: consulta.valorPropiedad
      };
      Vue.$log.info(response);
      commit(MUTATIONS.ON_CONSULTA_PH, simulacion);
      commit(MUTATIONS.ON_IS_LOADING, false);
      router.push("consulta-ph-valor-step3");
    } catch (error) {
      Vue.$log.error(error);
      commit(MUTATIONS.ADOBE_ERROR, error);
      router.push({
        name: "mensaje",
        params: {
          mje: "ERROR_SIMULACION_PH",
          buttonLabel: "Reintentar",
          link: {
            linkText: "Encontrar sucursal más cercana",
            linkUrl:
              "https://buscador.bbva.com.ar/buscadordecajerosysucursales/"
          }
        }
      });
    }
  },
  [ACTIONS.DO_CONTACTO_PH]: () => {
    router.push("contacto");
  },
  [ACTIONS.DO_CONFIRMAR_SIMULACION_PH]: (context, payload) => {
    const [dia, mes, anio] = payload.fechaNacimiento.split("/");
    const consulta = context.getters.getConsultaHipotecario();
    const simulacion = context.getters.getSimulacion();
    const isTasaPreferencial =
      window.location.hash.includes("tasa-preferencial");

    const sucursalSeleccionada = getBranchOfficeById(
      payload.sucursal,
      context.getters.getSucursales()
    );

    const simulacionPH = simulacion?.repagos[0];

    // S: Según ingresos, T: Según valor vivienda
    const modoSimulacion = payload.modo || "T";

    let valorPropiedad = "0";
    let dineroSolicitadoPesos = "0";
    let ingresoNetoMensual = "0";

    // dineroSolicitadoPesos: se toma el monto del cliente en vivienda
    // o de la rta simulacion (simulacionPH?.phEnPesos.montoAprobado) en ingresos
    if (simulacion && modoSimulacion === "T") {
      valorPropiedad = Math.floor(Number(simulacion.valorPropiedad));
      dineroSolicitadoPesos = parseCurrency(
        simulacion.montoSolicitado.toString()
      );
      ingresoNetoMensual = simulacionPH.sueldoNeto;
    } else if (simulacion && modoSimulacion === "S") {
      valorPropiedad = Math.floor(Number(simulacion?.valorPropiedadPesos));
      dineroSolicitadoPesos = simulacionPH?.phEnPesos.montoAprobado;
      ingresoNetoMensual = parseCurrency(simulacion.ingresos);
    }

    const confirmacionPayload = {
      acreditaSueldo: consulta.cuentaSueldo === "1",
      apellido: payload.apellido,
      cuotaPHMensualEnPesos: simulacionPH?.phEnPesos.cuota || "0",
      dineroSolicitadoPesos: dineroSolicitadoPesos,
      email: payload.email,
      fechaNacimientoAnio: anio,
      fechaNacimientoDia: dia,
      fechaNacimientoMes: mes,
      ingresoNetoMensual: ingresoNetoMensual,
      montoMaximoDisponibleEnPesos:
        simulacionPH?.phEnPesos.montoMaximoAprobado || "0",
      nacionalidad:
        payload.nacionalidad === "80" ? "ARGENTINA" : payload.nacionalidad,
      nombre: payload.nombre,
      nroDoc: payload.numeroDoc,
      nroTel: payload.celular.numero,
      sexo: payload.sexo,
      sucursal: sucursalSeleccionada,
      tipoDoc: payload.tipoDocumento,
      tipoPHElegido: consulta.destino,
      valorPropiedad: valorPropiedad,
      valorPropiedadUsd:
        Math.floor(Number(simulacion?.valorPropiedadUsd)) || "0",
      etapaBusqueda: consulta.etapa,
      modo: modoSimulacion === "T" ? "GBBT" : modoSimulacion,
      dineroSolicitadoUVA: simulacionPH?.phEnUVAs.montoAprobado || "0",
      tnaDeUVAs: simulacionPH?.tasaNominalAnual || "0",
      cotizacionUVA: simulacionPH?.phEnUVAs.cotizacionUVA || "0",
      fechaCotizacionUVA: simulacionPH?.phEnUVAs.fechaCotizacionUVA || "",
      teaDeUVAs: simulacionPH?.tasaEfectivaAnual || "0",
      cfteaDeUVAs: simulacionPH?.cftConIVA || "0",
      cfteaSinIVAdeUVAs: simulacionPH?.cftSinIVA || "0",
      cuotaPHMensualUVA: simulacionPH?.phEnUVAs.cuota || "0",
      plazoUVA: simulacion?.plazo * 12 || "0",
      asesoramiento: isTasaPreferencial ? false : payload.fromLanding,
      montoMaximoDisponibleEnUVAs: "0",
      cotizacionUsd: simulacion?.cotizacionUsd || "0"
    };

    if (isTasaPreferencial) {
      confirmacionPayload.tasaPreferencial = true;
    }

    context.commit(MUTATIONS.ON_IS_LOADING, true);

    // Ejecutar confirmación y guardado de lead en ASO para salesforce en paralelo
    const confirmarPHPromise = om.confirmarPH(confirmacionPayload);
    context.dispatch(ACTIONS.DO_GUARDAR_LEAD_PH, confirmacionPayload);

    confirmarPHPromise
      .then(response => {
        Vue.$log.info(response);
        if (response.data.status === "ERROR") {
          context.commit(MUTATIONS.ON_ERROR, response.data.respuesta);
          throw new Error(response.data.respuesta);
        }

        if (!simulacion) {
          context.commit(MUTATIONS.ON_CONSULTA_PH, {
            tipo: "asesoramiento",
            simulacion: null
          });
        }

        context.commit(MUTATIONS.ON_CONFIRMAR_SIMULACION_PH, response.data);

        router.push({
          name: "graciasPH",
          params: {
            asesoramiento: payload.fromLanding,
            tasaPreferencial: isTasaPreferencial
          }
        });
      })
      .catch(error => {
        Vue.$log.error(error);
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        context.commit(MUTATIONS.ADOBE_ERROR, error);
        router.push({
          name: "mensaje",
          params: {
            mje: "ERROR_CONFIRMACION_SIMULACION_PH",
            buttonLabel: "Reintentar",
            link: {
              linkText: "Encontrar sucursal más cercana",
              linkUrl:
                "https://buscador.bbva.com.ar/buscadordecajerosysucursales/"
            }
          }
        });
      })
      .finally(() => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
      });
  },
  [ACTIONS.DO_GUARDAR_LEAD_PH]: async (context, confirmacionPayload) => {
    try {
      // Primero consultar getSimulacionInput para el json formateado correctamente
      const simulacionInputResponse =
        await om.getSimulacionInput(confirmacionPayload);

      // Ejecucion de las consultas ASO
      await withTsecAuth(
        ASO.postMortgageSimulations,
        simulacionInputResponse.data.respuesta
      );

      Vue.$log.info("Lead PH guardado exitosamente");
    } catch (error) {
      // No lanzamos el error para no interferir con el flujo principal
      Vue.$log.error("Error al guardar lead PH:", error);
    }
  },
  [ACTIONS.DO_CONSULTA_PH_INCOME]: async ({ commit, dispatch }, consulta) => {
    const ingresos = Number(consulta.ingresos.toString().replace(/\D/g, ""));

    const consultaPayload = {
      modo: "S", // S: Según ingresos, T: Según valor vivienda
      codTipoProducto: "11",
      ingresos,
      montoSolicitado: 0,
      valorPropiedad: 0, // En este caso no se envía el valor de la propiedad
      plazo: consulta.plazo * 12,
      tipoVivienda: consulta.destino,
      cuentaSueldo: consulta.cuentaSueldo === "1"
    };

    dispatch(ACTIONS.DO_IS_LOADING_WITH_CONTENT, {
      loaderState: true,
      loaderContent: {
        loaderTitle: "Estamos calculando los resultados de tu simulación",
        loaderText:
          "El proceso puede tardar unos segundos. Por favor, no actualices esta pantalla."
      }
    });
    try {
      const response = await om.consultaPH(consultaPayload);
      if (response.data.status === "ERROR") {
        commit(MUTATIONS.ON_ERROR, response.data.respuesta);
        throw new Error(response.data.respuesta);
      }
      //guardo el valor ingresos del cliente
      const simulacion = {
        ...response.data.respuesta,
        plazo: consulta.plazo,
        ingresos: consulta.ingresos
      };
      Vue.$log.info(response);
      commit(MUTATIONS.ON_CONSULTA_PH, simulacion);
      dispatch(ACTIONS.DO_IS_LOADING_WITH_CONTENT, {
        loaderState: false,
        loaderContent: {
          loaderTitle: null,
          loaderText: null
        }
      });
      router.push("consulta-ph-ingresos-step3");
    } catch (error) {
      Vue.$log.error(error);
      commit(MUTATIONS.ADOBE_ERROR, error);
      router.push({
        name: "mensaje",
        params: {
          mje: "ERROR_SIMULACION_PH",
          buttonLabel: "Reintentar",
          link: {
            linkText: "Encontrar sucursal más cercana",
            linkUrl:
              "https://buscador.bbva.com.ar/buscadordecajerosysucursales/"
          }
        }
      });
    }
  },
  [ACTIONS.DO_ENVIAR_RENAPER]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    payload = {
      nombre: context.getters.getConsulta().nombre,
      apellido: context.getters.getConsulta().apellido,
      nroDoc: context.getters.getConsulta().numeroDoc,
      tipoDoc: context.getters.getConsulta().tipoDocumento,
      nacionalidad: context.getters.getConsulta().nacionalidad,
      sexo: context.getters.getConsulta().sexo,
      fechaNacimiento: context.getters.getConsulta().fechaNacimiento,
      expediente: payload.expediente
    };
    return om
      .enviarRenaper(payload)
      .then(response => {
        if (response.data.status === "OK") {
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          // Volver a llamar a doConsulta con el payload almacenado
          const payload = context.getters.getConsultaPayload();
          payload.captchaResponse = "CAPTCHA_VALIDATED";
          context.dispatch(ACTIONS.DO_REQUEST_API, {
            endPoint: END_POINTS.CONSULTAR_EVALUACION,
            doSuccess: ACTIONS.DO_PRIMERA_CONSULTA_SUCCESS,
            doError: ACTIONS.DO_CONSULTA_ERROR,
            payload
          });
        } else {
          router.push({
            name: "mensaje",
            params: {
              mje: "ACTUALIZAR_DATOS_RENAPER"
            }
          });
        }
      })
      .catch(error => {
        Vue.$log.error(error);
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        router.push({
          name: "mensaje",
          params: {
            mje: "mensaje-4"
          }
        });
      });
  },
  [ACTIONS.DO_FECHA_SISTEMA]: context => {
    const currentPath = window.location.hash;
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    return om
      .fechaSistema()
      .then(response => {
        context.commit(MUTATIONS.ON_FECHA_SISTEMA, response.data.fecha);
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        return true;
      })
      .catch(error => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        if (currentPath.includes("prescriptores")) {
          return router.push({
            name: "mensaje",
            params: {
              mje: "ERROR_GENERICO",
              buttonLabel: "Reintentar"
            }
          });
        }
        router.push({
          name: "mensaje",
          params: {
            mje: "ERROR_SIMULACION_PH",
            buttonLabel: "Reintentar",
            link: {
              linkText: "Encontrar sucursal más cercana",
              linkUrl:
                "https://buscador.bbva.com.ar/buscadordecajerosysucursales/"
            }
          }
        });
        throw error;
      });
  },
  [ACTIONS.DO_COTIZACION]: context => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    return om
      .cotizacionMonedaExtranjera()
      .then(response => {
        context.commit(
          MUTATIONS.ON_COTIZACION,
          response.data.respuesta[0].precioVenta
        );
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        return true;
      })
      .catch(error => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        router.push({
          name: "mensaje",
          params: {
            mje: "ERROR_SIMULACION_PH",
            buttonLabel: "Reintentar",
            link: {
              linkText: "Encontrar sucursal más cercana",
              linkUrl:
                "https://buscador.bbva.com.ar/buscadordecajerosysucursales/"
            }
          }
        });
        throw error;
      });
  },
  [ACTIONS.DO_PRESCRIPTOR]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    return om
      .getPrescriptor(payload)
      .then(response => {
        if (response.data.status === "ERROR") {
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          router.push({
            name: "mensaje",
            params: {
              mje: "ERROR_CODIGO_RECHAZADO",
              buttonLabel: "Reintentar"
            }
          });
          return false;
        }
        context.commit(MUTATIONS.ON_PRESCRIPTOR, response.data.respuesta);
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        router.push("recibir-asesoramiento-prescriptores-step2");
        return true;
      })
      .catch(error => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        router.push({
          name: "mensaje",
          params: {
            mje: "ERROR_PRESCRIPTOR",
            buttonLabel: "Reintentar"
          }
        });
        throw error;
      });
  },
  [ACTIONS.DO_CONFIRMAR_PRESCRIPTOR]: context => {
    const consulta = context.getters.getConsultaHipotecario();
    const datosForm = context.getters.getConsulta();
    const datosPrescriptor = context.getters.getPrescriptor();
    const [dia, mes, anio] = datosForm.fechaNacimiento.split("/");

    const confirmacionPayload = {
      apellido: datosForm.apellido,
      email: datosForm.email,
      fechaNacimientoAnio: anio,
      fechaNacimientoDia: dia,
      fechaNacimientoMes: mes,
      nacionalidad: datosForm.nacionalidad || "ARGENTINA",
      nombre: datosForm.nombre,
      nroDoc: datosForm.numeroDoc,
      nroTel: datosForm.celular.numero,
      sexo: datosForm.sexo,
      tipoDoc: datosForm.tipoDocumento,
      etapaBusqueda: consulta.etapa,
      nombreSucursalInmobiliaria: datosPrescriptor.sucursal,
      codigoPrescriptor: datosPrescriptor.codigo,
      cuitInmobiliaria: datosPrescriptor.cuit,
      emailInmobiliaria: datosPrescriptor.email,
      prescriptores: true,
      agenteInmobiliaria: datosPrescriptor.agente,
      nombrePrescriptor: datosPrescriptor.nombre
    };

    context.commit(MUTATIONS.ON_IS_LOADING, true);

    // Ejecutar confirmación y guardado de lead en ASO para salesforce en paralelo
    context.dispatch(ACTIONS.DO_GUARDAR_LEAD_PH, confirmacionPayload);

    om.confirmarPH(confirmacionPayload)
      .then(response => {
        Vue.$log.info(response);
        if (response.data.status === "ERROR") {
          context.commit(MUTATIONS.ON_ERROR, response.data.respuesta);
          throw new Error(response.data.respuesta);
        }

        context.commit(
          MUTATIONS.ON_CONFIRMAR_SIMULACION_PH,
          response.data.respuesta
        );

        router.push({
          name: "graciasPrescriptores"
        });
      })
      .catch(error => {
        Vue.$log.error(error);
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        router.push({
          name: "mensaje",
          params: {
            mje: "ERROR_GENERICO",
            buttonLabel: "Reintentar"
          }
        });
      })
      .finally(() => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
      });
  },
  [ACTIONS.DO_ACORTAR_URL]: (context, url) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    return om
      .acortarUrl(url)
      .then(response => {
        const uid = response.data.respuesta.uID;
        return uid;
      })
      .catch(error => {
        Vue.$log.error("Error al generar UID:", error);
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
        router.push({
          name: "mensaje",
          params: {
            mje: "mensaje-4"
          }
        });
      });
  },
  [ACTIONS.DO_URI_POR_UID]: (context, uid) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    return om
      .obtenerUriPorUid(uid)
      .then(response => {
        const uri = response.data.respuesta;
        return uri;
      })
      .catch(error => {
        Vue.$log.error("Error al obtener url:", error);
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
        router.push({
          name: "mensaje",
          params: {
            mje: "mensaje-4"
          }
        });
      })
      .finally(() => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
      });
  }
};
